import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function PenetrationTestingRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Penetration Testing Career Roadmap`}
      subtitle="Offensive Security Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-penetration-testing-roadmap.pdf"
      roleKey={roleKey || "penetrationtesting"}
    />
  );
}

